import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Module-level (not component state) — persists even if ScrollToTop itself ever
// gets remounted for some unrelated reason, so a scroll-to-top can never fire
// twice in a row for the same page no matter what's causing extra re-renders.
let lastScrolledPathname = null;

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (lastScrolledPathname === pathname) return; // already scrolled for this page — do nothing
    lastScrolledPathname = pathname;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
